export default __webpack_public_path__ + "static/media/bg1.e0c1beec.jpg";